
// 商品底部秒杀倒计时
import './index.less';

export const renderSecKillCountDown = ({ countdown, isSeckill, isActive = true }) => {
  if (!isSeckill) {
    return null;
  }
  return (
    <div className={`count-down-content ${isActive ? "active" : ""}`}>
      剩余{countdown}
    </div>
  );
};